document.addEventListener('click', function (e) {
  const btn = e.target.closest('.marker-quick-add__btn');
  if (!btn) return;

  const variantId = btn.dataset.variantId;
  btn.disabled = true;
  const originalText = btn.textContent;
  btn.textContent = 'Adding...';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
  })
    .then((res) => res.json())
    .then(() => {
      btn.textContent = 'Added ✓';
      btn.classList.add('is-added');

      fetch('/?sections=cart-drawer,cart-icon-bubble')
        .then((r) => r.json())
        .then((sections) => {
          const parser = new DOMParser();

          // Replace the ENTIRE <cart-drawer> element so it reinitializes correctly
          // (fixes empty-cart vs has-items state not updating)
          if (sections['cart-drawer']) {
            const newDoc = parser.parseFromString(sections['cart-drawer'], 'text/html');
            const newCartDrawer = newDoc.querySelector('cart-drawer');
            const oldCartDrawer = document.querySelector('cart-drawer');
            if (newCartDrawer && oldCartDrawer) {
              oldCartDrawer.replaceWith(newCartDrawer);
            }
          }

          // Update the little cart count bubble on the header icon
          const bubble = document.getElementById('cart-icon-bubble');
          if (bubble && sections['cart-icon-bubble']) {
            bubble.innerHTML = sections['cart-icon-bubble'];
          }

          // Open the freshly-swapped-in drawer
          const freshCartDrawer = document.querySelector('cart-drawer');
          if (freshCartDrawer && typeof freshCartDrawer.open === 'function') {
            freshCartDrawer.open();
          }
        })
        .catch(() => {
          console.warn('Cart drawer refresh failed, but item was added to cart.');
        });
    })
    .catch(() => {
      btn.textContent = 'Try again';
      btn.disabled = false;
    })
    .finally(() => {
      setTimeout(() => {
        if (!btn.classList.contains('is-added')) {
          btn.textContent = originalText;
          btn.disabled = false;
        }
      }, 2000);
    });
});